module.exports = __webpack_public_path__ + "static/media/stop.10b01020.png";